import DiseaseModal from './DiseaseModal'

export default DiseaseModal
